import { Routes } from '@angular/router';
import { LoginGuard, UnsupportedDeviceRouterGuard, UserRegistrationRouteGuard } from './router.guard';
import { UserGroups } from './constants/user-groups.constants';
export const routes: Routes = [
  {
    path: 'knox',
    loadComponent: () => import('./components/knox/knox.component').then(m => m.KnoxComponent),
    canActivate: [UserRegistrationRouteGuard],
    data: { roles: UserGroups.Viewer },
  },
  {
    path: 'unsupported',
    loadComponent: () =>
      import('./components/unsupported-browser/unsupported-browser.component').then(m => m.UnsupportedBrowserComponent),
    canActivate: [UnsupportedDeviceRouterGuard],
    data: { roles: UserGroups.Viewer },
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginGuard],
    data: { roles: UserGroups.Viewer },
  },
  { path: '', loadChildren: () => import('./components/core/core.routes').then(m => m.routes) },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
